(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "axios", "qs", "./constants", "./utils/config"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("axios"), require("qs"), require("./constants"), require("./utils/config"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.axios, global.qs, global.constants, global.config);
    global.request = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _axios, _qs, _constants, _config) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.baseIterableRequest = _exports.baseAxiosRequest = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _axios = _interopRequireDefault(_axios);
  _qs = _interopRequireDefault(_qs);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var baseAxiosRequest = _exports.baseAxiosRequest = _axios["default"].create({
    baseURL: _constants.BASE_URL
  });
  var baseIterableRequest = _exports.baseIterableRequest = function baseIterableRequest(payload) {
    try {
      var _payload$validation, _payload$validation2;
      if ((_payload$validation = payload.validation) !== null && _payload$validation !== void 0 && _payload$validation.data && payload.data) {
        payload.validation.data.validateSync(payload.data, {
          abortEarly: false
        });
      }
      if ((_payload$validation2 = payload.validation) !== null && _payload$validation2 !== void 0 && _payload$validation2.params && payload.params) {
        payload.validation.params.validateSync(payload.params, {
          abortEarly: false
        });
      }
      var baseURL = _config.config.getConfig('isEuIterableService') ? _constants.EU_ITERABLE_API : _config.config.getConfig('baseURL');
      return baseAxiosRequest(_objectSpread(_objectSpread({}, payload), {}, {
        baseURL: baseURL,
        headers: _objectSpread(_objectSpread({}, payload.headers), _constants.STATIC_HEADERS),
        paramsSerializer: function paramsSerializer(params) {
          return _qs["default"].stringify(params, {
            arrayFormat: 'repeat'
          });
        }
      }));
    } catch (error) {
      var _inner;
      /* match Iterable's API error schema and add client errors as a new key */
      var newError = {
        code: 'GenericError',
        msg: 'Client-side error',
        clientErrors: (_inner = error.inner) === null || _inner === void 0 ? void 0 : _inner.map(function (eachError) {
          return {
            error: eachError.message,
            field: eachError.path
          };
        })
      };
      /* match Axios' Error object schema and reject */
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        response: {
          data: newError,
          status: 400,
          statusText: '',
          headers: {},
          config: {}
        }
      });
    }
  };
});